import { G2WView } from './G2WView';
export class G2SView extends G2WView {
  constructor(g2sView = {}) {
    super(g2sView);
    this._watchTimeInPercent = g2sView.watchTimeInPercent;
    this._viewDurationInMillis = g2sView.viewDurationInMillis;
  }

  get watchTimeInPercent() {
    return this._watchTimeInPercent;
  }

  set watchTimeInPercent(value) {
    this._watchTimeInPercent = value;
  }

  get viewDurationInMillis() {
    return this._viewDurationInMillis;
  }

  set viewDurationInMillis(value) {
    this._viewDurationInMillis = value;
  }
}



// WEBPACK FOOTER //
// ./src/Model/Views/G2SView.js